<template>
  <div class="wrap text-center">
    <div class="content-wrap rounded">
      <div class="bg-light text-muted p-3 rounded d-flex justify-content-between align-items-center">
        <h4 class="mb-0">门票列表</h4>
        <!--<i class="iconfont cursor-pointer h2" @click="$emit('chooseTicket',tickets)">&#xe62d;</i>-->
        <i class="iconfont cursor-pointer h2" @click="$emit('chooseTicket','')">&#xe62d;</i>
      </div>
      <el-scrollbar style="height:400px">
        <ul class="d-flex align-items-center list-unstyled pt-2 pb-2 text-muted border-bottom">
          <li class="w-30"></li>
          <li class="w-30">产品名称</li>
          <li class="w-25">价格</li>
          <li class="w-25">选择</li>
        </ul>
        <ul class="d-flex align-items-center list-unstyled pt-2 pb-2 border-bottom" v-for="(item,index) in tickets" :key="index">
          <li class="w-30">{{item.ticket_species | formatVar('ticketTypeArr')}}</li>
          <li class="w-30">{{item.name}}</li>
          <li class="w-25">&yen;{{item.price3}}</li>
          <li class="w-25">
            <span class="select active" v-if="$GFUN.isInArray(selectedTickets,item.id)">已选择</span>
            <span class="select" v-else @click="selectedTickets.push(item.id)">选择</span>
          </li>
        </ul>
      </el-scrollbar>
      <el-button type="primary" size="mini" class="mt-2 mb-3" @click="$emit('chooseTicket',selectedTickets)">确定</el-button>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'ScenicTicketOpt',
    data() {
      return {
        selectedTickets: []
      }
    },
    props: {
      tickets: {},
      checkedTicket: {}
    },
    watch: {
      checkedTicket(newVal) {
        this.selectedTickets = newVal.map(v => v.id)
      }
    },
  }
</script>

<style lang="scss" scoped>
  .wrap {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, .4);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 10;
  }

  .content-wrap {
    background: #fff;
    width: 50%;
  }

  .select {
    width: 65px;
    height: 28px;
    line-height: 28px;
    color: #fff;
    background: var(--smtc-color-primary);
    border: 1px solid var(--smtc-color-primary);
    display: inline-block;
    border-radius: 2px;
    cursor: pointer;
    &:hover {
      background: #fff;
      color: var(--smtc-color-primary); 
    }
  }

  .select.active {
    background: #fff;
    color: var(--smtc-color-primary); 
    cursor: default;
  }
</style>
